module.exports = __webpack_public_path__ + "static/media/storelogo.1b1e1320.png";